class TimeStringHelper {
  static parseMinutesToString(t) {
    let hours = Math.trunc(t / 60);
    let minutes = t % 60;

    minutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${hours}:${minutes}`;
  }
}

export default TimeStringHelper;



// WEBPACK FOOTER //
// ./src/helpers/TimeStringHelper.js